export default function Testimonials() {
  const testimonials = [
    {
      quote: "ZJF IT Services has been instrumental in our expansion. Their field technicians are professional, punctual, and handle complex deployments with ease. They've become our go-to partner for all NYC-area projects.",
      author: "Michael Chen",
      role: "Operations Director",
      company: "TechBridge Solutions"
    },
    {
      quote: "The 24-48 hour dispatch guarantee is a game-changer. We can confidently promise our clients fast turnaround times knowing ZJF will deliver. Their white-label approach makes them feel like part of our team.",
      author: "Sarah Martinez",
      role: "VP of Client Services",
      company: "Northeast IT Partners"
    },
    {
      quote: "From structured cabling to workstation rollouts, ZJF handles it all. Their attention to detail and consistent quality has helped us scale our MSP business without adding overhead. Highly recommended.",
      author: "David Thompson",
      role: "Founder & CEO",
      company: "Apex Managed Services"
    }
  ];

  return (
    <section id="testimonials-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-zinc-900 mb-4">
            Trusted by <span className="text-orange-500">Leading MSPs</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See what our partners say about working with ZJF IT Services
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-zinc-50 rounded-lg p-8 border border-zinc-200 hover:border-orange-500 transition-all duration-300 hover:shadow-lg"
            >
              <div className="flex items-center justify-center w-12 h-12 mb-6">
                <i className="ri-double-quotes-l text-4xl text-orange-500"></i>
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-sm">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-zinc-200 pt-6">
                <p className="font-semibold text-zinc-900 text-sm">{testimonial.author}</p>
                <p className="text-xs text-gray-600">{testimonial.role}</p>
                <p className="text-xs text-orange-500 font-medium mt-1">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="flex items-center justify-center w-16 h-16 bg-orange-500/10 rounded-full mb-3 mx-auto">
              <i className="ri-shield-check-line text-3xl text-orange-500"></i>
            </div>
            <p className="text-2xl font-bold text-zinc-900">15+</p>
            <p className="text-sm text-gray-600">MSP Partners</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center w-16 h-16 bg-orange-500/10 rounded-full mb-3 mx-auto">
              <i className="ri-time-line text-3xl text-orange-500"></i>
            </div>
            <p className="text-2xl font-bold text-zinc-900">24-48hr</p>
            <p className="text-sm text-gray-600">Dispatch Time</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center w-16 h-16 bg-orange-500/10 rounded-full mb-3 mx-auto">
              <i className="ri-map-pin-line text-3xl text-orange-500"></i>
            </div>
            <p className="text-2xl font-bold text-zinc-900">Nationwide</p>
            <p className="text-sm text-gray-600">Coverage</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center w-16 h-16 bg-orange-500/10 rounded-full mb-3 mx-auto">
              <i className="ri-star-line text-3xl text-orange-500"></i>
            </div>
            <p className="text-2xl font-bold text-zinc-900">100%</p>
            <p className="text-sm text-gray-600">White-Label</p>
          </div>
        </div>
      </div>
    </section>
  );
}
